import { render } from "./PostView.vue?vue&type=template&id=5d537730&scoped=true"
import script from "./PostView.vue?vue&type=script&lang=js"
export * from "./PostView.vue?vue&type=script&lang=js"

import "./PostView.vue?vue&type=style&index=0&id=5d537730&lang=css"
import "./PostView.vue?vue&type=style&index=1&id=5d537730&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d537730"]])

export default __exports__